import script from "./PayStackContribution.vue?vue&type=script&setup=true&lang=js"
export * from "./PayStackContribution.vue?vue&type=script&setup=true&lang=js"

import "./PayStackContribution.vue?vue&type=style&index=0&id=bd8897e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd8897e2"]])

export default __exports__